import request from '@/utils/request';
// 忘记密码验证
export default {
  verifyResetPwdToken: data =>
    request(`/oauth2/oauth/reset/password/${data.tenant_id}/${data.token_id}`, {
      method: 'get',
    }),
  // 验证手机号及验证码
  verifyResetPwdTokenByPhone: data =>
    request(`/oauth2/oauth/reset/password/${data.phone}/${data.code}`, {
      method: 'post',
      body: data,
    }),

  // 校验邮箱验证码
  verifyEmailCode: data =>
    request(`/ess/user/email/check/verifyCode`, {
      method: 'get',
      params: {
        email: data.email,
        code: data.code,
      },
    }),

  verifyPhoneCode: data =>
    request('/captcha/sms/reset/password/phone', {
      method: 'post',
      body: data,
    }),
  // 重置密码
  resetPwdByToken: data =>
    request('/oauth2/oauth/reset/password', {
      method: 'post',
      body: data,
    }),
  // 提交邮箱验证
  fetchResetPasswordToken: data =>
    request('/oauth2/oauth/reset/password/token', {
      method: 'post',
      body: data,
    }),
  // 提交手机号码获取验证码
  fetchResetPasswordTokenByPhone: data =>
    request(`/captcha/sms/sendVerifyCodeSms/${data}`, {
      method: 'get',
    }),
  // 更改邮箱提交手机号码获取验证码
  ResetEmailTokenByPhone: data =>
    request(`/captcha/sms/sendCodeSmsByEmail/${data}`, {
      method: 'get',
    }),

  // 更改邮箱确认邮箱取验证码
  getEmailVerifyCode: email =>
    request(`/ess/user/email/verifyCode`, {
      method: 'get',
      params: { email: email },
    }),

  // 联系我们
  contactUs: data =>
    request('/oauth2/oauth/contactus', {
      method: 'post',
      body: data,
    }),

  // 验证密码
  verifyPassword: data =>
    request('/oauth2/privilege/verify/password', {
      method: 'post',
      body: data,
    }),

  // 是否配置智能客服
  bdaiCheck: () =>
    request('/corehr/bdai/check', {
      method: 'get',
    }),
};
